import game from '../game/Game'
import { NEW_GAME, SELECT_ROBOT, MOVE_ROBOT, LOAD_STATE } from '../actions/game'
import { CHANGE_NEW_CHALLENGE_ROBOT } from '../actions/ChallengeMaker'

export default function robot(state = {}, action) {
  switch (action.type) {
    case NEW_GAME:
      return action.robots
    case MOVE_ROBOT:
      return action.robots
    case LOAD_STATE:
      return action.robots
    case SELECT_ROBOT:
      return state
    case CHANGE_NEW_CHALLENGE_ROBOT:
      let color = action.color
      return Object.assign({}, state, {
        [color]: Object.assign({}, state[color], { location : action.location })
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/robot.js